import { animate, keyframes, style, transition, trigger } from '@angular/animations';

export const DISABLED_INITIAL_ANIMATION = trigger('disabledInitial', [
  transition(':enter', []),
]);

export const FADE_IN_ANIMATION = trigger('show', [
  transition(':enter', [style({ opacity: 0 }), animate('0.2s ease-in', style({ opacity: 1 }))]),
]);

export const FADE_IN_OUT_ANIMATION = trigger('show', [
  transition(':enter', [style({ opacity: 0 }), animate('0.2s ease-in', style({ opacity: 1 }))]),
  transition(':leave', [style({ opacity: 1 }), animate('0.2s ease-out', style({ opacity: 0 }))]),
]);

export const HEIGHT_ANIMATION = trigger('height', [
  transition(':enter', [
    style({ height: 0, overflow: 'hidden' }),
    animate('0.2s', style({ height: '*', overflow: 'hidden' })),
  ]),
  transition(':leave', [
    style({ height: '*', overflow: 'hidden' }),
    animate('0.2s', style({ height: 0, overflow: 'hidden' })),
  ]),
]);

export const WIDTH_ANIMATION = trigger('width', [
  transition(':enter', [
    style({ width: 0, overflow: 'hidden' }),
    animate('0.2s', style({ width: '*', overflow: 'hidden' })),
  ]),
  transition(':leave', [
    style({ width: '*', overflow: 'hidden' }),
    animate('0.2s', style({ width: 0, overflow: 'hidden' })),
  ]),
]);

export const MIN_WIDTH_ANIMATION = trigger('minWidth', [
  transition(':enter', [
    style({ minWidth: 0, overflow: 'hidden' }),
    animate('0.2s', style({ minWidth: '*', overflow: 'hidden' })),
  ]),
  transition(':leave', [
    style({ minWidth: '*', overflow: 'hidden' }),
    animate('0.2s', style({ minWidth: 0, overflow: 'hidden' })),
  ]),
]);

export const BACKGROUND_ANIMATION = trigger('backgroundAnimation', [
  transition('* => true', [
    animate(
      '0.3s cubic-bezier(0,0.5,0.5,0)',
      keyframes([
        style({ backgroundColor: '*' }),
        style({ backgroundColor: '#88cafc' }),
        style({ backgroundColor: '*' }),
      ]),
    ),
  ]),
]);
